import * as Yup from "yup";

export const ApplyLeaveSchema = Yup.object({

    leave_type: Yup.string().required("Select Leave Type"),
    sub_type: Yup.string().required("Select Leave Sub Type"),
    date: Yup.date().min(new Date().toISOString().split('T')[0], "Select Future date").required("Select Date"),
    remark: Yup.string().notRequired("Enter Remark"),

});